import React, { useState } from "react";
import { Navigate, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/authContext";
import {
    doCreateUserWithEmailAndPassword,
    doSignInWithGoogle,
} from "../../../firebase/auth";
import "./register.css";

const Register = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setconfirmPassword] = useState("");
    const [isRegistering, setIsRegistering] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const { userLoggedIn } = useAuth();

    const onSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setErrorMessage("Passwords do not match");
            return;
        }
        if (!isRegistering) {
            setIsRegistering(true);
            setErrorMessage(""); // Clear any previous error messages
            try {
                await doCreateUserWithEmailAndPassword(email, password);
                // Redirect to subscriptions page after successful registration
                navigate("/subscriptions");
            } catch (error) {
                console.error("Error registering user:", error);
                setErrorMessage("Registration failed. Please try again.");
            } finally {
                setIsRegistering(false);
            }
        }
    };

    const handleGoogleRegister = async () => {
        if (!isRegistering) {
            setIsRegistering(true);
            setErrorMessage(""); // Clear any previous error messages
            try {
                await doSignInWithGoogle();
                navigate("/subscriptions");
            } catch (error) {
                console.error("Error registering user with Google:", error);
                setErrorMessage("Google registration failed. Please try again.");
            } finally {
                setIsRegistering(false);
            }
        }
    };

    return (
        <div className="login-page">
            {userLoggedIn && <Navigate to={"/bot"} replace={true} />}
            <main className="main-content">
                <div className="login-box">
                    <div className="text-center">
                        <div className="welcome-message">
                            <h3>Create a New Account</h3>
                        </div>
                    </div>
                    <form onSubmit={onSubmit} className="login-form">
                        <div className="form-group">
                            <label className="form-label">Email</label>
                            <input
                                type="email"
                                autoComplete="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="form-input"
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Password</label>
                            <input
                                disabled={isRegistering}
                                type="password"
                                autoComplete="new-password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="form-input"
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Confirm Password</label>
                            <input
                                disabled={isRegistering}
                                type="password"
                                autoComplete="off"
                                required
                                value={confirmPassword}
                                onChange={(e) => setconfirmPassword(e.target.value)}
                                className="form-input"
                            />
                        </div>
                        {errorMessage && (
                            <span className="error-message">{errorMessage}</span>
                        )}
                        <button
                            type="submit"
                            disabled={isRegistering}
                            className="submit-button"
                        >
                            {isRegistering ? "Signing Up..." : "Sign Up"}
                        </button>
                        <div className="signup-link">
                            Already have an account? <Link to={"/login"}>Login</Link>
                        </div>
                    </form>
                </div>
            </main>
        </div>
    );
};

export default Register;